import { render, staticRenderFns } from "./empowerdd.vue?vue&type=template&id=fc5a4c0a&"
import script from "./empowerdd.vue?vue&type=script&lang=js&"
export * from "./empowerdd.vue?vue&type=script&lang=js&"
import style0 from "./empowerdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports